import styled from "styled-components";

export const HeaderExportWrapper = styled.div`
  width: 100%;
  text-align: center;
  color: #00a8ff;
  .title {
    font-size: 24px;
    font-weight: 700;
  }
  .last-update {
    font-size: 14px;
  }
  .hospital {
    margin-top: 8px;
    font-weight: bold;
    font-size: 20px;
    font-style: italic;
  }
`;
